import { Box, Tooltip } from "@material-ui/core";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { UserContext } from "../../contexts/UserContext";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";

import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllJobApplications = () => {
  const navigate = useNavigate();
  const classes = useAdminStyles();
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    Axios.get("/api/admin/job_applications", { headers: { headKey } }).then(
      (res) => {
        if (res.status === 200 && res.data.status) {
          setData(res.data.data);
          setLoading(false);
          $(document).ready(function () {
            $("#applications_table").DataTable({ destroy: true, order: [[0, "desc"]] });
          });
        } else {
          setUser(null);
          navigate("/");
        }
      }
    );
  }, []);

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Job Applications - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Careers"
        title="Job Applications"
        subtitle="Applications submitted through the careers page. View or download each CV."
      />

      <Box className={classes.tableWrap}>
        <table
          id="applications_table"
          className="display"
          style={{ width: "100%" }}
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Applicant</th>
              <th>Role</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Applied</th>
              <th>CV / Links</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((da) => (
                <tr key={da.id}>
                  <td>{da.id}</td>
                  <td style={{ fontWeight: 600, color: "#1a1a1a" }}>
                    {da.first_name} {da.last_name}
                  </td>
                  <td>{da.job_title || "Job #" + da.job_id}</td>
                  <td>
                    <a href={"mailto:" + da.email}>{da.email}</a>
                  </td>
                  <td>{da.mobile}</td>
                  <td>{da.applied}</td>
                  <td>
                    <Box className={classes.actionCell}>
                      {da.cv_url && (
                        <Tooltip title="View CV" arrow>
                          <a
                            href={da.cv_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.iconBtn}
                            aria-label="View CV"
                          >
                            <DescriptionOutlinedIcon />
                          </a>
                        </Tooltip>
                      )}
                      {da.linkedin_url && (
                        <Tooltip title="LinkedIn" arrow>
                          <a
                            href={da.linkedin_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.iconBtn}
                            aria-label="LinkedIn"
                          >
                            <LinkedInIcon />
                          </a>
                        </Tooltip>
                      )}
                    </Box>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
